<template>
    <v-app id="app">
        <v-app-bar shrink-on-scroll prominent app>
            <v-img class="header-logo" :src="require('./assets/dw.png')" contain height="100%" max-width="180px" @click="goHome"/>

            <v-row class="ml-2" align="center" style="height: 100%;">
                <span class="title font-weight-light ml-4" @click="goHome">Alibaba Dragonwell</span>
                <v-spacer></v-spacer>
                <v-menu offset-y open-on-hover>
                    <template v-slot:activator="{ on }">
                        <v-btn text class="subtitle-2 grey--text text--darken-2" v-on="on">FEATURES</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in items" :key="index" :href="item.href"
                                     target="_blank">
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn text class="subtitle-2 grey--text text--darken-2"
                       href="https://github.com/alibaba/dragonwell8/wiki/Alibaba-Dragonwell8-User-Guide"
                       target="_blank">
                    DOCUMENTS
                </v-btn>
                <v-btn text class="subtitle-2 grey--text text--darken-2"
                       href="http://ci.dragonwell-jdk.io/job/build-scripts/job/openjdk8-pipeline/"
                       target="_blank">
                    CI/CD
                </v-btn>
                <v-menu offset-y open-on-hover>
                    <template v-slot:activator="{ on }">
                        <v-btn text class="subtitle-2 grey--text text--darken-2" v-on="on">Tools</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in toolIndexes" :key="index" :href="item.href"
                                     target="_blank">
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn text class="subtitle-2 grey--text text--darken-2"
                       href="https://github.com/alibaba/dragonwell8/wiki/Alibaba-Dragonwell8-FAQ"
                       target="_blank">
                    FAQ
                </v-btn>
                <v-btn text class="subtitle-2 grey--text text--darken-2"
                       href="https://www.aliyun.com/product/dragonwell"
                       target="_blank">
                    ABOUT
                </v-btn>
                <v-btn icon color="grey" href="https://github.com/alibaba/dragonwell8" target="_blank">
                    <v-icon>mdi-github-face</v-icon>
                </v-btn>
            </v-row>
        </v-app-bar>

        <v-main>
            <!-- <home></home> -->
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
    // import Home from "./components/Home";

    export default {
        components: {
           // Home
        },
        data: () => ({
            items: [
                {
                    text: "JWarmup",
                    href: "https://github.com/alibaba/dragonwell8/wiki/Alibaba-Dragonwell8-User-Guide#jwarmup"
                },
                {
                    text: "ElasticHeap",
                    href: "https://github.com/alibaba/dragonwell8/wiki/Alibaba-Dragonwell8-User-Guide#g1elasticheap"
                },
                {
                    text: "Wisp",
                    href: "https://github.com/alibaba/dragonwell8/wiki/Wisp-Documentation"
                }
            ],

            toolIndexes: [
                {
                    text: "Eclipse Jifa Demo",
                    href: "http://jifa.dragonwell-jdk.io/"
                },
            ],
        }),
        methods: {
            goHome() {
                this.$router.push({path: '/'})
            },
        }
    };
</script>

<style>
    #app {
        background-color: var(--v-background-base);
        font-family: firasansregular;
    }
    .header-logo {
        cursor: pointer;
    }
    .title {
        cursor: pointer;
    }
    .title:hover {
        color: var(--v-anchor-base);
    }
</style>
